import React from 'react'
import propTypes from 'prop-types'
import HtmlToReact from "html-to-react";
import Cta from '../Cta';

const HtmlParser = ({
    html,
    dropText
}) => {
    
    const parser = new HtmlToReact.Parser();
    const wysiwygCtaClasses = ['primary'];

    const CustomA = props => {
        return (
            <Cta
                inline
                href={props.href}
                target={props.target}
                type={'outline'}
                // type={props.class.split(' ')[0]}
            >
            {props.children}
            </Cta>
        );
    };

    const processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);

    const processingInstructions = [
        {
          shouldProcessNode: node => {

            const className = (node.name === "a" && node.attribs && node.attribs.class) ? node.attribs.class.split(' ').find(item => {
                return wysiwygCtaClasses.indexOf(item) !== -1 
            }) : undefined;
           
            return (node && node.name === "a") && className;
          },
          processNode: (node, children) => {
            return <CustomA {...node.attribs}>{children}</CustomA>;
          }
        },
        {
            // Anything else
            shouldProcessNode: function(node) {
                return true;
            },
            processNode: processNodeDefinitions.processDefaultNode
        }
    ]
    const wrapDropText = (content) => {
        return content
    }

    const modifiedHtml = dropText ? wrapDropText(html) : html

    // console.log('modifiedHtml', modifiedHtml);

    return (
    	<div>
            {parser.parseWithInstructions(
                modifiedHtml,
                () => true,
                processingInstructions
            )}
        </div>
    )
}
    
HtmlParser.propTypes = {
}
    
HtmlParser.defaultProps = {
    dropText: false
}
    
export default HtmlParser